export default __webpack_public_path__ + "static/media/Flag_of_Ireland.4021ef40.svg";